/**
 * FloatingActionButton Component
 * 
 * Botão de ação flutuante reutilizável.
 * Aparece no canto inferior direito da tela.
 * 
 * Funcionalidades:
 * - Posicionamento fixo no canto inferior direito
 * - Ícone customizável
 * - Ação customizável
 * - Estado de desabilitado
 */

import { Save } from 'lucide-react'
import './FloatingActionButton.css'

function FloatingActionButton({ 
  icon: Icon = Save, 
  onClick, 
  disabled = false,
  label = '',
  variant = 'primary'
}) {
  return (
    <button
      className={`floating-action-button ${variant} ${disabled ? 'disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
      title={label}
    >
      <Icon size={24} />
      {label && <span className="fab-label">{label}</span>}
    </button>
  )
}

export default FloatingActionButton

